const defaults = (override, defs) => {
  const res = Object.assign({}, defs);
  const safeOverride = override || {};
  Object.entries(safeOverride).forEach((entry) => {
    const [k, v] = entry;
    if (v !== undefined) {
      res[k] = v;
    }
  });
  return res;
};

export default {
  defaults,
};



// WEBPACK FOOTER //
// src/core/utils.js